
import 'react-toastify/dist/ReactToastify.css';
import { useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import 'react-phone-input-2/lib/style.css'
import './CountryCourses.css';
import { useGetCourseCountryWiseQuery} from "../../../Services/api";

export const featuresData = [
    {
        id: 1,
        title: "Australia",
        href: "/country-course-details/1",
        description: "Australia Training Services.",
        amount: 299,
        thumbnail: process.env.REACT_APP_PUBLIC_STORAGE_URL + "training/aus.jpeg",
    },
    {
        id: 2,
        title: "USA",
        href: "/country-course-details/2",
        description: "United States of America Training Services.",
        amount: 299,
        thumbnail: process.env.REACT_APP_PUBLIC_STORAGE_URL + "training/usa.jpeg",
    },
    {
        id: 3,
        title: "United Kingdom",
        href: "/country-course-details/3",
        description: "United Kingdom Training Services.",
        amount: 299,
        thumbnail: process.env.REACT_APP_PUBLIC_STORAGE_URL + "training/uk.jpeg",
    },
    {
        id: 4,
        title: "Philippines",
        href: "/country-course-details/4",
        description: "Philippines Training Services.",
        amount: 249,
        thumbnail: process.env.REACT_APP_PUBLIC_STORAGE_URL + "training/phil.jpeg",
    },
    {
        id: 5,
        title: "United Arab Emirates",
        href: "/country-course-details/5",
        description: "United Arab Emirates Training Services.",
        amount: 249,
        thumbnail: process.env.REACT_APP_PUBLIC_STORAGE_URL + "training/uae.jpeg",
    },
    {
        id: 6,
        title: "Guinea",
        href: "/country-course-details/6",
        description: "Guinea Training Services.",
        amount: 199,
        thumbnail: process.env.REACT_APP_PUBLIC_STORAGE_URL + "training/guinea.jpeg",
    }
];


export default function CountryCoursesDetails() {
    const { id: countryId } = useParams();
    
    const {
        data: courseCountryWise,
        isLoading: isCoursesLoading,
        isError: isCoursesError,
    } = useGetCourseCountryWiseQuery({ params: countryId });
    const location = useLocation();
    const [cartItems, setCartItems] = useState([]);
    const [isCartOpen, setIsCartOpen] = useState(false);

    const addToCart = (feature) => {
        setCartItems([feature]);
        setIsCartOpen(true);
    };

    const removeFromCart = (featureId) => {
        setCartItems((items) => items.filter((item) => item.id !== featureId));
    };
    const countryCourses = courseCountryWise?.data || [];
    const selectedCountry = featuresData.find((feature) => String(feature.id) === String(countryId));
   
   const countryIndex = Number(countryId) - 1;

const courseCards = countryCourses.map((course) => {
    let amounts = [];

    try {
        amounts = Array.isArray(course.amount)
            ? course.amount
            : JSON.parse(course.amount || "[]");
    } catch (error) {
        console.error("Invalid amount:", course.amount);
    }

    return {
        id: course.course_id,
        title: course.course_name,

        description:
            course.short_name ||
            selectedCountry?.description ||
            "Training course.",

        amount: Number(amounts[countryIndex] || 0),

        thumbnail:
            course.course_image ||
            selectedCountry?.thumbnail,

        currencyCode:
            course.currency?.[countryIndex]?.code || "USD",

        currencySymbol:
            course.currency?.[countryIndex]?.symbol || "$",
    };
});

    const cartTotal = cartItems.reduce((total, item) => total + Number(item.amount || 0), 0);

    return (
            <main className="country-courses-page ">
                <section className="country-courses-section">
                    <div className="country-courses-container">
                        <nav className="country-navbar" aria-label="Country course navigation " style={{ marginBottom: "20px" }}>
                            <div className="country-navbar-inner">
                                <div className="country-navbar-links">
                                    {featuresData.map((feature) => (
                                        <Link
                                            key={feature.id}
                                            className={`country-navbar-link${location.pathname === feature.href ? " is-active" : ""}`}
                                            to={feature.href}
                                        >
                                            {feature.title}
                                        </Link>
                                    ))}
                                </div>
                                <div className="country-cart-wrap">
                                    <button
                                        className="country-cart-button"
                                        type="button"
                                        aria-label={`Shopping cart with ${cartItems.length} items`}
                                        aria-expanded={isCartOpen}
                                        onClick={() => setIsCartOpen((open) => !open)}
                                    >
                                        <span>Cart</span>
                                        <span className="country-cart-count">{cartItems.length}</span>
                                    </button>
                                    {isCartOpen && (
                                        <div className="country-cart-panel">
                                            <div className="country-cart-panel-header">
                                                <span>{cartItems.length} item{cartItems.length === 1 ? "" : "s"}</span>
                                            </div>
                                            {cartItems.length === 0 ? (
                                                <p className="country-cart-empty">Your cart is empty.</p>
                                            ) : (
                                                <>
                                                    <div className="country-cart-items">
                                                       
                                                        {cartItems.map((item) => (
                                                            <div className="country-cart-item" key={item.id}>
                                                                <span>{item.title}</span>
                                                                <button type="button" onClick={() => removeFromCart(item.id)}>
                                                                    Remove
                                                                </button>
                                                                <strong> {item.currencySymbol}{Number(item.amount || 0).toFixed(2)}</strong>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className="country-cart-total">
                                                        <span>Total</span>
                                                        <strong>
                                                            {cartItems[0]?.currencySymbol || "$"} {cartTotal.toFixed(2)}
                                                        </strong>
                                                    </div>
                                                    <Link className="country-checkout-button" to={`/signup/${cartItems[0].id}/${countryId}`}>
                                                        Checkout
                                                    </Link>
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </nav>
                        {isCoursesLoading && <p className="country-courses-status">Loading courses...</p>}
                        {isCoursesError && <p className="country-courses-status">Unable to load courses for this country.</p>}
                        {isCoursesError && courseCards.length > 0 && (
                            <p className="country-courses-status">Showing the country course while the course list is unavailable.</p>
                        )}
                       
                        <div className="country-courses-grid">
                            {/* {console.log("courseCards", courseCards)} */}
                            {courseCards.map((feature) => (
                                <div
                                    key={feature.id}
                                    className="country-course-card"
                                >
                                    
                                        <div className="country-course-card-content">
                                            <div className="country-course-image-frame">
                                                <img
                                                    width={200}
                                                    height={200}
                                                    src={feature.thumbnail}
                                                    alt={`${feature.title} training services`}
                                                />
                                            </div>
                                            <h5>
                                                {feature.title}
                                            </h5>
                                            <p className="country-course-description">
                                                {feature.description}
                                            </p>
                                        </div>
                                         <div className="country-course-card-footer">
                                        <strong className="country-course-amount">
                                            {feature.currencySymbol} {Number(feature.amount || 0).toFixed(2)}
                                        </strong> 
                                        <button
                                            className="country-add-to-cart"
                                            type="button"
                                            onClick={() => addToCart(feature)}
                                            disabled={cartItems.some((item) => item.id === feature.id)}
                                        >
                                            {cartItems.some((item) => item.id === feature.id) ? "Added" : "Add to cart"}
                                        </button>
                                    </div>
                                    
                                   
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
    );
}